import {globalMessageHandler, Rules, ValidationErrors, Validator} from "../../../../common";
import {getPaymentInformation, ManagePaymentsForm, updatePayments} from "./ManagePaymentsApi";
import {useEffect, useState} from "react";

export function validateManagePaymentsForm(values: ManagePaymentsForm) {
  const rules: Rules = {
    billing_first_name: Validator.rule.string().required(),
    billing_last_name: Validator.rule.string().required(),
    billing_street: Validator.rule.string().required(),
    billing_city: Validator.rule.string().required(),
    billing_country: Validator.rule.string().required(),
    billing_state: Validator.rule.string().required(),
    billing_zip: Validator.rule.string().required(),
    billing_phone: Validator.rule.string().required(),
  };
  return Validator.validate(rules, values, "ManagePaymentsForm");
}

export default function useManagePaymentsForm() {
  const [item, setItem] = useState<ManagePaymentsForm>({} as ManagePaymentsForm);
  const [preLoading, setPreLoading] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [errors, setErrors] = useState<ValidationErrors>({});

  useEffect(() => {
    async function updatePaymentInformationItem() {
      setItem(await getPaymentInformation());
      setPreLoading(false);
    }

    updatePaymentInformationItem();
  }, []);

  async function process() {
    setLoading(true);
    const result = validateManagePaymentsForm(item);
    setErrors(result.errors);

    const response = await updatePayments(item);
    setLoading(false);

    if (response.success) {
      globalMessageHandler.success("Saved TODO");
    } else {
      setErrors(response.error.form_errors);
    }
  }

  function onChange(values: ManagePaymentsForm) {
    setItem(values);
  }

  return {
    item,
    loading,
    preLoading,
    process,
    errors,
    onChange,
  };
}